import axios from '@fs/zion-axios'

const BASE_SENSITIVE_PATH = '/service/dmc/sensitive'

export async function getMatchTermsFiltered(term, category, lang) {
  const params = {
    category,
    lang,
  }
  return axios.get(`${BASE_SENSITIVE_PATH}/match-terms/${encodeURIComponent(term)}`, { params })
}

export async function getMatchTerms(category, lang) {
  const params = {
    category,
    lang,
  }
  return axios.get(`${BASE_SENSITIVE_PATH}/match-terms`, { params })
}

export async function postMatchTerm(body) {
  return axios.post(`${BASE_SENSITIVE_PATH}/match-terms`, body)
}

export async function deleteMatchTerm(id) {
  return axios.delete(`${BASE_SENSITIVE_PATH}/match-terms/${id}`)
}
